import React, { useEffect, useState } from 'react';
import { Button, Modal, Form, Select,Popconfirm, Typography, message} from 'antd';
import { useSelector } from 'react-redux';
import axiosInstance from '../../utils/axiosInstance'; // Update path as needed
import { useParams } from 'react-router-dom';

const { Text } = Typography;

const UserAccess = ({ contract, fetchContracts }) => {
    const [isUserAddModalVisible, setIsUserAddModalVisible] = useState(false);
    const [addUserForm] = Form.useForm();
    const [companyUsers, setCompanyUsers] = useState([]);
    const select = useSelector((state) => state.auth.userInfo);
    const role = select.role;
    const user_email = select.user_email;
    const user_id = select.user_id;
    const compnayId = localStorage.getItem("companyId") || select.company_id;
    const params = useParams();
    const fetchCompanyUsers = async () => {
        try {
            const response = await axiosInstance.post(`/user/get_user_email/`, {
                company_id: compnayId,
                is_active: true,
            })
            const existIds = contract.contract_access_users.map((item) => item.id)
            const newOptions = response.data.data.filter((item) => !existIds.includes(item.id)).map((item) => ({
                value: item.email,
                label: `${item.first_name} (${item.role})`,
            }));
            setCompanyUsers(newOptions);
        } catch (error) { }
    };

    useEffect(() => {
        fetchCompanyUsers()
    }, [compnayId]);

    const showUserAddModal = () => setIsUserAddModalVisible(true);
    const handleModalCancel = () => setIsUserAddModalVisible(false);

    const handleAddUserSubmit = (values) => {
        let emails = values.user_email;
        if (typeof emails === 'string') emails = emails.split(',');
        const assign = values.assign !== false;

        axiosInstance
            .put(`contract/${params.pk || contract.id}/assign/`, {
                user_email: emails,
                assign,
                company_id: compnayId,
            })
            .then((res) => {
                message.success(res.data.message || 'Users updated');
                fetchContracts && fetchContracts();
                setIsUserAddModalVisible(false);
                addUserForm.resetFields();
            })
            .catch(() => {
                message.error('Failed to update users');
            });
    };

    const handleRemoveUser = (email) => {
        handleAddUserSubmit({ user_email: email, assign: false });
    };

    return (
        <>
            <div className="text-black pb-2 pt-1 flex items-center justify-between">
                <div className='flex items-center justify-between gap-2 py-1 w-full'>
                    <h1 className="text-[14px] font-bold dark:text-gray-200">Contract Access Users</h1>
                    {contract.status !== 'EXECUTED' && role && parseInt(user_id) === parseInt(contract.editable_user) &&
                        contract.status !== 'TRANSACTION_CLOSED' && (
                            <button onClick={showUserAddModal} className='text-[#4E36A3] border border-[#4E36A3] rounded-md px-2 py-1 hover:bg-[#4E36A3] hover:text-white transition-all duration-300 flex items-center justify-center gap-1 text-[12px] font-semibold'> + User </button>
                        )}
                </div>
                <Modal
                    title="Add User"
                    open={isUserAddModalVisible}
                    onOk={() => addUserForm.submit()}
                    onCancel={handleModalCancel}
                    okText="Save"
                >
                    <Form form={addUserForm} onFinish={handleAddUserSubmit}>
                        <Form.Item
                            name="user_email"
                            label="Select User"
                            rules={[{ required: true, message: 'Please select users' }]}
                        >
                            <Select
                                options={companyUsers.sort((a, b) =>
                                    a.label.localeCompare(b.label)
                                )}
                                isMulti
                                required
                                closeMenuOnSelect={false}
                            />
                        </Form.Item>
                    </Form>
                </Modal>
            </div>
            <div className="space-y-2 px-1 pb-2 flex-1 overflow-y-scroll">
                {contract?.contract_access_users?.map((user, index) => (
                    <div key={index} className="border rounded-xl shadow-sm p-2">
                        <div className="flex items-center justify-between">
                            <div className="font-semibold text-[13px]">
                                {user.first_name} {user.last_name || ''}
                            </div>
                            {role &&
                                contract.created_by === user_email &&
                                user.email !== user_email && (
                                    <Popconfirm
                                        title="Remove this user"
                                        description="Are you sure to remove this user?"
                                        onConfirm={() => handleRemoveUser(user.email)}
                                        okText="Yes"
                                        cancelText="No"
                                    >
                                        <Button danger size="small">
                                            Remove
                                        </Button>
                                    </Popconfirm>
                                )}
                        </div>
                        <div className="flex justify-between text-[11px]">
                            <div>
                                <div>
                                    <span className="font-semibold text-gray-700">Email:</span>{' '}
                                    <Text>{user.email}</Text>
                                </div>
                                <div>
                                    <span className="font-semibold text-gray-700">Role:</span>{' '}
                                    {user.role}
                                </div>
                                <div>
                                    <span className="font-semibold text-gray-700">Department:</span>{' '}
                                    {user.department?.name || '—'}
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </>
    );

};

export default UserAccess;
